// Presence-Avatare in der Canvas-Topbar. Zeigt eigene + remote User mit Farb-Punkt.

import { useTranslation } from "react-i18next";
import type { AwarenessUser, RemotePresence } from "../realtime/use-awareness.js";

interface PresenceProps {
  self: AwarenessUser | null;
  presences: readonly RemotePresence[];
}

export function Presence({ self, presences }: PresenceProps): JSX.Element {
  const { t } = useTranslation();
  const total = (self ? 1 : 0) + presences.length;
  return (
    <div className="canvas-presence" aria-label={t("canvas.presence", { count: total })}>
      <span className="canvas-presence-count">{total}</span>
      <ul>
        {self && (
          <li className="canvas-presence-avatar is-self" title={`${self.name} (you)`}>
            <span className="canvas-presence-dot" style={{ background: self.color }} />
            <span className="canvas-presence-initial">{initials(self.name)}</span>
          </li>
        )}
        {presences.map((p) => (
          <li className="canvas-presence-avatar" key={p.clientId} title={p.user.name}>
            <span className="canvas-presence-dot" style={{ background: p.user.color }} />
            <span className="canvas-presence-initial">{initials(p.user.name)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}
